module.exports = __webpack_public_path__ + "static/media/010.d357ab83.jpg";